/**
 * Generic bounded-concurrency runner. Runs `worker` over `items` allowing at
 * most `concurrency` in-flight calls at any time, resolving with the results
 * array in the same order as `items` (regardless of completion order).
 *
 * Default concurrency (4) matches the backend's MAX_WORKERS thread pool
 * (api/api.py) so the frontend never puts more parallel pressure on CKAN
 * than the backend itself is sized to absorb.
 */
export const DEFAULT_CONCURRENCY = 4

export async function runConcurrent(items, worker, concurrency = DEFAULT_CONCURRENCY, onItemSettled) {
  const results = new Array(items.length)
  let cursor = 0

  async function runOne() {
    while (cursor < items.length) {
      const index = cursor
      cursor += 1
      const item = items[index]
      try {
        results[index] = await worker(item, index)
      } catch (error) {
        results[index] = { error }
      }
      if (onItemSettled) {
        onItemSettled(item, index, results[index])
      }
    }
  }

  const workerCount = Math.max(0, Math.min(concurrency, items.length))
  const runners = Array.from({ length: workerCount }, runOne)
  await Promise.all(runners)

  return results
}

export default runConcurrent
